<template>
  <div class="flex flex-col lg:flex-row w-full lg:items-center xl:w-2/3">
    <div class="w-full lg:w-1/2 mb-4 lg:mb-0 lg:mr-3 md:flex-1">
      <input
        v-model="search"
        type="text"
        placeholder="Search"
        @keyup.enter="searchCourse"
        class="cursor-pointer focus:outline-none focus:border-gray-800 focus:shadow-outline-gray text-sm form-select block w-full py-2 px-2 xl:px-3 border border-gray-300 rounded text-gray-600 appearance-none bg-transparent"
      />
    </div>
    <div class="">
      <CourseFilters
        v-model="selectedFilter"
        @applyFilters="handleApplyFilters"
        :hideSortProgress="props.hideSortProgress"
        :hideEnrolledProgress="props.hideEnrolledProgress"
        :hideAvailableCourse="props.hideAvailableCourse"
        />
    </div>
    <div class="mx-4">
      <button
        type="button"
        @click="handleClickResetFilter"
        class="relative flex gap-x-2 bg-white justify-center items-center shadow hover:bg-untitled-gray-200 cursor-pointer focus:outline-none focus:border-untitled-gray-200 focus:shadow-outline-gray text-sm form-select w-1/8 py-2 px-2 xl:px-3 border border-untitled-gray-100 rounded appearance-none text-untitled-gray-800 hover:text-untitled-gray-900"
      >
        Reset
      </button>
    </div>
    <div>
      <CategoriesMegaMenu v-if="false" />
      <DropDownMenu />
    </div>
  </div>
</template>

<script setup>
import { useEnrolledCourseStore } from "@/stores/enrolledCourseStore";
import CategoriesMegaMenu from "./CategoriesMegaMenu/CategoriesMegaMenu.vue";
import {
  defineProps,
  defineEmits,
  computed,
  onUnmounted,
  defineAsyncComponent,
} from "vue";

const CourseFilters = defineAsyncComponent(() => import("./CourseFilters.vue"));
const DropDownMenu = defineAsyncComponent(() =>
  import("@/components/element-components/DropdownMenu.vue")
);

const props = defineProps({
  selectedFilter: {
    type: Object,
    required: false,
  },
  search: {
    type: String,
    required: true,
  },
  hideSortProgress: {
    type: Boolean,
    default: false
  },
  hideEnrolledCourse: {
    type: Boolean,
    default: false
  },
  hideAvailableCourse: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([
  "update:selectedFilter",
  "update:search",
  "onApplyFilters",
  "onSearchCourse",
  "onResetFilters",
]);

const enrolledCourseStore = useEnrolledCourseStore();

const selectedFilter = computed({
  get() {
    return props.selectedFilter;
  },
  set(newValue) {
    emit("update:selectedFilter", newValue);
  },
});

const search = computed({
  get() {
    return props.search;
  },
  set(newValue) {
    emit("update:search", newValue);
  },
});

const handleApplyFilters = () => {
  emit("onApplyFilters");
};

const searchCourse = () => {
  emit("onSearchCourse");
};

const handleClickResetFilter = () => {
  emit("onResetFilters");
};

const handleInitializeFilters = () => {
  enrolledCourseStore.selectedFilter = null;
};

onUnmounted(() => {
  handleInitializeFilters();
});
</script>

<style lang="scss" scoped></style>
